import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Dialog, Button } from "@shared/components";

const useStyles = makeStyles((theme) => ({
  message: {
    textAlign: "center",
    fontSize: 18,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(4),
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(4),
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: theme.spacing(3),
    },
  },
}));

interface SubmitAnotherFormDialogProps {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

const SubmitAnotherFormDialog: FunctionComponent<SubmitAnotherFormDialogProps> = ({ open, onYes, onNo }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={() => onNo()}
      title="Submit Another Form"
      maxWidth="sm"
      fullWidth
      closeOnBackdropClick={false}
    >
      <Box>
        <Typography className={classes.message}>Do you want to submit another form?</Typography>
        <Box className={classes.buttonContainer}>
          <Button variant="contained" color="primary" onClick={onYes} size="medium" testId="submit-another-yes">
            Yes
          </Button>
          <Button variant="outlined" color="primary" onClick={onNo} size="medium" testId="submit-another-no">
            No
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SubmitAnotherFormDialog;
